import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import { handleIdentifyHint, intl } from 'utils'
import keyMirror from 'pkeymirror'
import { getSalt, removeSalt } from 'store/siteConfig'
import { Toast } from 'antd-mobile'
import messages from 'languages/messages'

// ------------------------------------
// Constants
// ------------------------------------
export const BANK_CARD_MAIN = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  UNBIND_CARD_REQUEST: null,
  UNBIND_CARD_SUCCESS: null,
  VERIFY_PASSWORD_REQUEST: null,
  VERIFY_PASSWORD_SUCCESS: null,
  CHECK_BINDCARD_PERMISSION_REQUEST: null,
  CHECK_BINDCARD_PERMISSION_SUCCESS: null,
}, 'BANK_CARD_MAIN')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        endpoint: 'cgs/personal/card/queryCardList',
        requestAction: BANK_CARD_MAIN.INIT_REQUEST,
        successAction: BANK_CARD_MAIN.INIT_SUCCESS,
        success: function(result) {
          dispatch(checkBindCardPermission())
        },
      })
    )
  }
}

export function checkBindCardPermission() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          sceneCode: 'BIND_CARD',
        },
        endpoint: 'cgs/personal/whitelist/check',
        requestAction: BANK_CARD_MAIN.CHECK_BINDCARD_PERMISSION_REQUEST,
        successAction: BANK_CARD_MAIN.CHECK_BINDCARD_PERMISSION_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

export function unBindCard(data) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/personal/common/unBindCard',
        requestAction: BANK_CARD_MAIN.UNBIND_CARD_REQUEST,
        successAction: BANK_CARD_MAIN.UNBIND_CARD_SUCCESS,
        success: function(result) {
          const currentIdentifyHint = handleIdentifyHint(result.identifyHint)
          if (currentIdentifyHint.method === 'PASSWORD') {
            return dispatch(getSalt())
          }
          Toast.info(intl.formatMessage(messages.settingProceededSuccessfully), 2, () => {
            dispatch(init())
          })
        },
      })
    )
  }
}

export function verifyPassword(data, errCallback) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/personal/card/PasswordVerify',
        requestAction: BANK_CARD_MAIN.VERIFY_PASSWORD_REQUEST,
        successAction: BANK_CARD_MAIN.VERIFY_PASSWORD_SUCCESS,
        success: function(result) {
          Toast.info(intl.formatMessage(messages.settingProceededSuccessfully), 2, () => {
            dispatch(removeSalt())
            dispatch(init())
          })
        },
        error: function(result) {
          dispatch(getSalt())
          errCallback()
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BANK_CARD_MAIN.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [BANK_CARD_MAIN.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [BANK_CARD_MAIN.UNBIND_CARD_REQUEST]: (state, action) => state,
  [BANK_CARD_MAIN.UNBIND_CARD_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [BANK_CARD_MAIN.VERIFY_PASSWORD_REQUEST]: (state, action) => state,
  [BANK_CARD_MAIN.VERIFY_PASSWORD_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [BANK_CARD_MAIN.CHECK_BINDCARD_PERMISSION_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [BANK_CARD_MAIN.CHECK_BINDCARD_PERMISSION_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  cardList: []
}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'bankCardMain',
    reducerMap: {
      bankCardMainState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
